import React from "react";
import type { ILandingHeaderProps } from "../LandingHeader/LandingHeader";
import HeaderPetitPrince from "./HeaderPetitPrince/HeaderPetitPrince";
import { _LandingHeaderHighlightProductRoot } from "./LandingHeaderHighlightProduct.styled";
import LandingHighlighProductPetitPrince, {
  type ILandingHighlighProductPetitPrinceProps,
} from "../LandingHighlighProduct/LandingHighlighProductPetitPrince/LandingHighlighProductPetitPrince";
import StyledDiv, { IStyledDivStyles } from "../../StyledDiv/StyledDiv";

interface ILandingHeaderHighlightProductProps {
  headerProps: ILandingHeaderProps;
  productProps: ILandingHighlighProductPetitPrinceProps;
  styles?: IStyledDivStyles;
}

const LandingHeaderHighlightProduct = (
  props: ILandingHeaderHighlightProductProps
) => {
  const { headerProps, productProps, styles } = props;

  return (
    <StyledDiv
      as={_LandingHeaderHighlightProductRoot}
      className="landing-header-highlight-product"
      style={{
        zIndex: 0,
        willChange: "auto",
      }}
      styles={styles}
    >
      <HeaderPetitPrince title={headerProps.description || ""} />
      <StyledDiv
        styles={{
          height: 32,
          mobile: {
            display: "block",
            height: 256,
          },
        }}
      />
      <LandingHighlighProductPetitPrince {...productProps} />
    </StyledDiv>
  );
};

export default React.memo(LandingHeaderHighlightProduct);
